import React from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import App from '../modularReduxComponents/App/index';
import PhoneNumberInput from '../modularReduxComponents/PhoneNumber/index.tsx';
import ChooseRole from '../modularReduxComponents/ChooseRole/index';
import ConfirmCode from '../modularReduxComponents/ConfirmCode/index';
import LoginContainer from '../modularReduxComponents/Login/container';
import ForgotPasswordContainer from '../modularReduxComponents/ForgotPassword/container';
import ResetPassword from '../modularReduxComponents/ResetPassword/container';
import ReturningUserCompleteContainer from '../modularReduxComponents/ReturningUserComplete/container';
import VerifyDeclined from '../modularReduxComponents/VerifyDeclined/container.tsx';
import VerifyHardDeclined from '../modularReduxComponents/VerifyDeclined/VerifyHardDeclined.tsx';
import WidgetPage from '../modularReduxComponents/WidgetPage/container.tsx';
import ReturningChildCompleteContainer from '../modularReduxComponents/ReturningChildComplete/container';
import ChildDOB from '../modularReduxComponents/ChildDOB/index.tsx';
import NeedParent from '../modularReduxComponents/NeedParent';
import InAppContainer from '../modularReduxComponents/InApp/container.tsx';
import ApproverDeclined from '../modularReduxComponents/ApproverDeclined/index.tsx';
import VerifyEmail from '../modularReduxComponents/VerifyEmail/index.tsx';
import PreRegSetPlan from '../modularReduxComponents/PreRegSetPlan/index.tsx';
import ParentInvite from '../modularReduxComponents/ParentInvite/index.tsx';
import ParentInviteComplete from '../modularReduxComponents/ParentInviteComplete/index.tsx';

import { AnalyticsProvider } from '../ModularReduxAnalytics';

const RESET_PASSWORD_ROUTE_BASE = '/reset-password/:type';
const RESET_PASSWORD_ROUTE_PARAMS = '/:uid/:token';
export const RESET_PASSWORD_ROUTE = `${RESET_PASSWORD_ROUTE_BASE}${RESET_PASSWORD_ROUTE_PARAMS}`;

class _PhoneNumberResetPage extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    if (this.props.location.pathname === '/') {
      if (this.props.persistor) {
        this.props.persistor.purge();
      }
    }
  }

  render() {
    return <PhoneNumberInput />;
  }
}
const PhoneNumberResetPage = withRouter(_PhoneNumberResetPage);

const AppComponent = props => (
  <AnalyticsProvider>
    <InAppContainer authToken={props.authToken} accessToken={props.accessToken}>
      <App>
        <Switch>
          <Route
            exact
            path="/"
            render={() => (
              <PhoneNumberResetPage
                persistor={props.persistor}
                store={props.store}
                {...props}
              />
            )}
          />
          <Route path="/forgot-password" component={ForgotPasswordContainer} />
          <Route
            path={RESET_PASSWORD_ROUTE_BASE}
            render={() => (
              <ResetPassword
                {...props}
                userId={props.userId}
                resetToken={props.resetToken}
              />
            )}
          />
          <Route path="/choose-role" component={ChooseRole} />
          <Route path="/choose-plan" component={PreRegSetPlan} />
          <Route path="/enter-dob" component={ChildDOB} />
          <Route path="/confirm-code" component={ConfirmCode} />
          <Route path="/login" component={LoginContainer} />
          <Route path="/complete" component={ReturningUserCompleteContainer} />
          <Route
            path="/child-complete"
            component={ReturningChildCompleteContainer}
          />
          <Route path="/need-parent" component={NeedParent} />
          <Route path="/verify-declined" component={VerifyDeclined} />
          <Route path="/verify-hard-declined" component={VerifyHardDeclined} />
          <Route path="/approver-declined" component={ApproverDeclined} />
          <Route path="/reg" render={() => <WidgetPage {...props} />} />
          <Route path="/verify-email" component={VerifyEmail} />
          <Route path="/parent-invite" component={ParentInvite} />
          <Route
            path="/parent-invite-complete"
            component={ParentInviteComplete}
          />
          <Route component={PhoneNumberInput} />
        </Switch>
      </App>
    </InAppContainer>
  </AnalyticsProvider>
);

export default AppComponent;
